import * as React from "react";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import * as _ from "lodash";
import { AirMeltIndustryInfo, VacuumIndustryInfo } from "../schema-types";
import ClearIcon from '@mui/icons-material/Clear';

require("./styles.scss");

interface IndustryMultiSelectUIProps {
  currentSelection: any; 
  industryInfo: AirMeltIndustryInfo | VacuumIndustryInfo;
  updateSelections: (event: any, value: any) => void;
}
export class IndustryMultiSelectUI extends React.PureComponent<
  IndustryMultiSelectUIProps,
  {}
> {
  render() {
    let industryInfo = this.props.industryInfo;
    let alphabetizedOptions = _.sortBy(industryInfo.options, "label");
    let deduplicatedOptions = _.uniqBy(alphabetizedOptions, "label").filter(opt => {
      return !this.props.currentSelection.includes(opt.value);
    });

    return (
      <div className="industry-name-multiselect" key={industryInfo.category!}>
        <label>{industryInfo.category}</label> 
        <Autocomplete
          multiple
          size="small"
          id="tags-outlined"
          options={deduplicatedOptions}
          filterSelectedOptions={false}
          onChange={(event, value) => this.props.updateSelections(event, value)}
          value={this.props.currentSelection}
          limitTags={2}
          isOptionEqualToValue={(option, value) => option.value === value}
          renderInput={(params) => (
            <TextField
              {...params}
            />
          )}
          clearIcon={<ClearIcon />} 
        /> 
      </div>
    );
  }
}
